export default function PriceBadge({ price, size = "md", tone = "light", className = "" }) {
  const sizeMap = {
    sm: "text-[10px] tracking-[0.20em] px-2.5 py-1",
    md: "text-[11px] tracking-[0.22em] px-3 py-1.5",
    lg: "text-xs tracking-[0.22em] px-4 py-2",
  };
  const toneClass =
    tone === "dark"
      ? "border border-white/25 bg-white/10 backdrop-blur text-white"
      : tone === "solid"
      ? "border border-transparent bg-[#0B2545] text-white"
      : "border border-[#0B2545]/20 bg-white text-[#0B2545]";
  return (
    <div
      className={`inline-flex items-baseline gap-2 uppercase font-mono ${sizeMap[size]} ${toneClass} ${className}`}
      data-testid="price-badge"
    >
      <span className="opacity-60">From</span>
      <span className="font-semibold">${price}</span>
      <span className="opacity-60">/day</span>
    </div>
  );
}
